import {
  INSERT_TIPO_ATIVIDADES,
  INSERT_TIPO_ESCALAS,
  INSERT_TIPO_DOCUMENTOS,
  INSERT_TIPOS_CONFERENCIA,
  INSERT_HIPOTESES_LEGAL,
  INSERT_INFORMACAO_USUARIO,
  INSERT_SUBSTANCIAS,
  INSERT_SUPERFICIARIOS
} from '../actions/actionTypes';

const initialState = {
  tipoAtividades: [],
  tipoEscalas: [],
  tipoDocumentos: [],
  tiposConferencia: [],
  hipotesesLegal: [],
  substancias: [],
  superficiarios: [],
  informacaoUsuario: {
    id: '',
    nomeCompleto: '',
    cpf: '',
    isPessoaJuridica: false,
    razaoSocialEmpresa: '',
    cnpj: '',
    crea: '',
    juntaComercial: '',
    endereco: '',
    complemento: '',
    bairro: '',
    municipio: '',
    uf: '',
    cep: ''
  }
};

export const responseReducer = (state = initialState, action) => {
  switch (action.type) {
    case INSERT_TIPO_ATIVIDADES:
      return {
        ...state,
        tipoAtividades: action.newValue
      };

    case INSERT_TIPO_ESCALAS:
      return {
        ...state,
        tipoEscalas: action.newValue
      };

    case INSERT_TIPO_DOCUMENTOS:
      return {
        ...state,
        tipoDocumentos: action.newValue
      };

    case INSERT_TIPOS_CONFERENCIA:
      return {
        ...state,
        tiposConferencia: action.newValue
      };

    case INSERT_HIPOTESES_LEGAL:
      return {
        ...state,
        hipotesesLegal: action.newValue
      };

    case INSERT_INFORMACAO_USUARIO: {
      return {
        ...state,
        informacaoUsuario: action.newValue || state.informacaoUsuario
      };
    }

    case INSERT_SUBSTANCIAS:
      return {
        ...state,
        substancias: action.newValue
      };

    case INSERT_SUPERFICIARIOS:
      return {
        ...state,
        superficiarios: action.newValue
      };

    default:
      return state;
  }
};
